'use strict';

function buildVMT(classDef, method) {
    var result = [];
    while (classDef) {
        var p = classDef.prototype;
        if (p.hasOwnProperty(method)) result.push(classDef);
        classDef = classDef.___parentClass;
    }

    return result;
}

module.exports = {
    extend: function (parentClass, objDef, classHint) {
        var newClass = parentClass.extend(objDef);
        var instanceData = {};
        newClass.___classHint = classHint;
        newClass.___parentClass = parentClass;
        newClass.___firstAncestor = parentClass.___firstAncestor || parentClass;

        var createMethod = function (intf, owner, ctx, method) {
            Object.defineProperty(intf, method, {
                get: function () {
                    if (!ctx.vmt[method]) {
                        ctx.vmt[method] = buildVMT(newClass, method);
                    }

                    if (!ctx.currentParentMethod[method]) ctx.currentParentMethod[method] = 1;

                    var methodIdx = ctx.currentParentMethod[method];
                    var currentParentClass = ctx.vmt[method][methodIdx];
                    if (!currentParentClass) {
                        currentParentClass = newClass.___firstAncestor;
                    }

                    var currentParentClassPrototype = currentParentClass.prototype;

                    if (!currentParentClassPrototype[method]) return undefined;

                    return function () {
                        // make step forward
                        ctx.currentParentMethod[method]++;
                        var methodFct = currentParentClassPrototype[method];
                        var rv = undefined;
                        if (methodFct) rv = methodFct.apply(owner, arguments);
                        ctx.currentParentMethod[method]--;
                        return rv;
                    };
                },
            });
        };

        var createInterface = function (owner, ctx) {
            var intf = {};

            for (var prop in ctx.currentParent.prototype) {
                if (typeof ctx.currentParent.prototype[prop] !== 'function') continue;

                createMethod(intf, owner, ctx, prop);
            }
            return intf;
        };

        var createNewInstanceCtx = function (owner) {
            var ctx = {
                currentParent: parentClass,
                currentParentMethod: {},
                vmt: {},
            };
            var intf = createInterface(owner, ctx);
            ctx.intf = intf;

            return ctx;
        };

        Object.defineProperty(newClass.prototype, 'base', {
            get: function () {
                if (!this.___instanceCtx) this.___instanceCtx = createNewInstanceCtx(this);

                return this.___instanceCtx.intf;
            },
        });

        return newClass;
    },

    inheritedObj: function (oldName, newData) {
        return function () {
            if (!this.___instanceCtx) var dummy = this.base;

            if (!this.___instanceCtx) throw 'the object has to be created via OOP.extend';

            var pc = this.___instanceCtx.currentParent.prototype;
            var oldData = pc[oldName];
            if (typeof oldData == 'function') {
                var fct = this.base[oldName];
                if (fct) oldData = fct.apply(this);
                else oldData = undefined;
            }

            var newObj = {};
            _.each(oldData, function (value, key) {
                newObj[key] = value;
            });
            _.each(newData, function (value, key) {
                newObj[key] = value;
            });
            return newObj;
        };
    },
};
